var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoElo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2423.67 2295.08",
    style: {
      enableBackground: "new 0 0 2423.67 2295.08"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1361.07,2043.26 1361.05,2043.26 1361.05,302.22 1048.96,302.22 1048.96,2043.26 1049.01,2043.26  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.4,2057.1c-74.12,0-164.66-14.2-164.66-14.2c-139.32-32.88-221.58-110.27-221.58-217.27V862.19 c0-144.27,149.58-234.74,386.93-234.74c237.31,0,386.86,90.47,386.86,234.74v513.5H408.27v445.05c0,63.59,29.25,68.45,74.81,68.45 c45.51,0,74.77-4.86,74.77-68.45v-327.65h312.09v332.54c0,107.23-82.63,184.73-222.49,217.47v0.16 C647.45,2043.26,549.68,2057.1,482.4,2057.1z M557.85,867.1c0-63.59-29.26-68.47-74.77-68.47c-45.56,0-74.81,4.88-74.81,68.47 v344.77h149.58V867.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1936.3,2057.28c-67.21,0-173.92-14.01-173.92-14.01l-1.24-0.21c-139.75-32.77-222.26-110.25-222.26-217.42V862.19 c0-144.27,149.54-234.74,386.86-234.74c237.35,0,386.87,90.47,386.87,234.74v963.44c0,107.36-82.75,184.92-222.88,217.57l0.57,0.06 C2090.29,2043.26,2000.52,2057.28,1936.3,2057.28z M2000.52,867.1c0-63.59-29.26-68.47-74.78-68.47s-74.77,4.88-74.77,68.47v953.64 c0,63.56,29.25,68.45,74.77,68.45s74.78-4.86,74.78-68.45V867.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.56,300.37 90.56,527.54 877.82,527.52 877.82,300.37  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElo);
export default __webpack_public_path__ + "static/media/logo_elo.e0b96ab5263a6278067ffb2cc0556327.svg";
export { ForwardRef as ReactComponent };